import {
  TOGGLE_SELECTED_SOCIAL_ACCOUNTS,
  SET_SOCIAL_ACCOUNTS,
  SET_SELECTED_SOCIAL_ACCOUNTS,
  SET_SELECTED_SOCIAL_ACCOUNT_SINGLE,
  SET_SELECTED_SOCIAL_ACCOUNTS_FOR_DRAFTS,
} from "../_actions/types";

export const initialState = {
  accounts: [],
  selected: [],
  selectedSingle: null, // used in places where only single account selection is allowed
  selectedForDrafts: [],
};

const socialAccountsReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_SELECTED_SOCIAL_ACCOUNTS: {
      const accountsIds = state.accounts.map((item) => item.id);
      const selected = [...state.selected];
      const value = action.payload.value;

      action.payload.ids.forEach((id) => {
        const index = selected.indexOf(id);

        if (value) {
          if (index === -1) {
            selected.push(id);
          }
        } else {
          if (index > -1) {
            selected.splice(index, 1);
          }
        }
      });

      return {
        ...state,
        selected: selected.filter((id) => accountsIds.includes(id)),
      };
    }
    case SET_SELECTED_SOCIAL_ACCOUNTS: {
      const accountsIds = state.accounts.map((item) => item.id);
      const selected = [...action.ids];

      return {
        ...state,
        selected: selected.filter((id) => accountsIds.includes(id)),
      };
    }
    case SET_SELECTED_SOCIAL_ACCOUNT_SINGLE: {
      return {
        ...state,
        selectedSingle: action.id,
      };
    }
    case SET_SELECTED_SOCIAL_ACCOUNTS_FOR_DRAFTS: {
      const accountsIds = state.accounts.map((item) => item.id);
      const selected = [...action.ids];

      return {
        ...state,
        selectedForDrafts: selected.filter((id) => accountsIds.includes(id)),
      };
    }
    case SET_SOCIAL_ACCOUNTS: {
      const accounts = action.payload || [];
      const accountsIds = accounts.map((item) => item.id);
      const selected =
        state.selected?.filter((id) => accountsIds.includes(id)) || [];

      const selectedForDrafts =
        state.selectedForDrafts?.filter((id) => accountsIds.includes(id)) || [];

      const result = {
        ...state,
        accounts,
        selected,
        selectedForDrafts,
      };

      /*
        no account selected for single selection (required) OR selected account
        is not longer available -> select first available account;
      */
      if (
        !state.selectedSingle ||
        !accounts.find((account) => account.id === state.selectedSingle)
      ) {
        result.selectedSingle = accounts[0]?.id;
      }

      /* since backend doesn't respond with accounts data after they are connected,
        for now we do the comparison to find new accounts and select them here.
        This is to auto select newly added accounts.
      */

      if (action.options?.selectNewAccounts) {
        const oldAccountsIds = state.accounts.map((account) => account.id);
        const newAccountsIds = accountsIds.filter(
          (id) => !oldAccountsIds.includes(id)
        );

        result.selected = [...result.selected, ...newAccountsIds];
      }

      return result;
    }
    default:
      return state;
  }
};

export default socialAccountsReducer;
